export const tipsy_discord = 'https://discord.gg/Wzp9zdyEkU'
export const tipsy_twitter = 'https://x.com/tipsy_chat'
export const tipsy_ins = 'https://www.instagram.com/tipsychat'
export const tipsy_tiktok = 'https://www.tiktok.com/@tipsychat.official'
export const tipsy_youtube = 'https://www.youtube.com/@Tipsychatofficial'
export const tipsy_facebook = 'https://www.facebook.com/tipsychat'
export const tipsy_reddit = 'https://www.reddit.com/r/TipsyChatOfficial'
